export default "__VITE_ASSET__ZnfzHry8__"